/* eslint-disable arrow-body-style */
import { useEffect, useMemo, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'umi';
import { getFunnelDailySelectorList } from '@/pages/dashboard/services/funnel';
import { formatSortFiltersData } from '../../utils/_config/formatSortFiltersData';
import { findPageSelector } from '../../components/NewFilter/util';
interface IProps {
  // 页面路径
  path: string;
  // 不展示的筛选器不请求下拉数据
  visibleZeroReq?: boolean;
}

export const useFilterData = (props: IProps) => {
  const { path, visibleZeroReq = false } = props || {};
  const [loading, setLoading] = useState(true); // 筛选器loading
  const selectorRef = useRef<any>();

  const { gameConfig, dataFrame, gameCode } = useSelector((state: any) => {
    return {
      gameConfig: state?.dashboardSetting?.gameConfig || {},
      dataFrame: state.dashboard?.currentGame?.data_frame || 'mobile',
      gameCode: state.dashboard?.currentGame?.game_code
    };
  }, shallowEqual);

  const filterParamList = useMemo(() => {
    const { default_selector: defaultSelector = [], page_selector: pageSelector = [] } = gameConfig || {};
    const filterParamConfig = findPageSelector(path, pageSelector, defaultSelector, dataFrame);

    if (visibleZeroReq) {
      return filterParamConfig?.filter(item => item?.visible === 1)?.map(item => item?.key) || [];
    }
    return filterParamConfig?.map(item => item?.key) || [];
  }, [gameConfig, dataFrame, visibleZeroReq, path]);

  // 初始化
  useEffect(() => {
    if (gameCode) {
      getFunnelDailySelectorList({
        game_code: gameCode,
        selector_list: filterParamList,
        // platform: 'pc',
        path: `/${path}`,
      }).then((data) => {
        const dataResult = formatSortFiltersData(data || {});
        let userTypeOptions = [];
        if (dataResult?.user_type) {
          userTypeOptions = dataResult?.user_type?.filter((item: { code: string; }) => item?.code?.toLowerCase() !== 'all');
        }
        selectorRef.current = {
          ...dataResult,
          user_type: userTypeOptions,
          stage: dataResult?.stage?.map((item: { [key:string]: string;})=>{
            return {
              ...item,
              stage_id: item?.code,
              stage_no: item?.sn,
              stage_name_en: item?.name_en,
              stage_name_ch: item?.name_ch,
            };
          }) || [],
          attachmentData: dataResult?.attachment_data
        };
      }).catch((error) => {
        console.log('getFunnelDailySelectorList~error', error);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [path, gameCode, filterParamList.toString()]);

  return {
    loading,
    selector: selectorRef.current
  };
};
